<template>
<div style="width: 100%;" class="mt-4 scroll">
    <p class="font-semibold" style="font-size: 17px;">Crear comunicación</p>
    <vs-divider></vs-divider>
    <div class="mt-4">
        <p class="font-bold letra">Tipo de comunicación:</p>
        <v-select :options="arregloTipos" @input="filtrarTipos(comunicacion.tipo)" :reduce="arregloTipos => arregloTipos.id" label="label" class="w-full" v-model="comunicacion.tipo" />
    </div>
    <div style="margin-top: 25px;" v-if="(comunicacion.tipo == 1 || comunicacion.tipo == 2 || comunicacion.tipo == 3) && usuario.id_group != 6">
        <p class="font-bold letra">Docente:</p>
        <v-select :options="arregloDocentes" @input="filtrarCurso()" :reduce="arregloDocentes => arregloDocentes.idusuario" label="docente" class="w-full" v-model="comunicacion.usuario" />
    </div>
    <!-- {{ arregloDocentes }} docentes -->
    <div style="margin-top: 25px;" v-if="comunicacion.tipo == 1 ||  comunicacion.tipo == 3">
        <p class="font-bold letra">Materia:</p>
        <v-select :options="arregloMaterias" @input="getCursosDocente()" :reduce="arregloMaterias => arregloMaterias.idlibro" label="nombrelibro" class="w-full" v-model="comunicacion.materia" />
    </div>
    <div style="margin-top: 25px;" v-if="comunicacion.tipo == 1 || comunicacion.tipo == 3">
        <p class="font-bold letra">Cursos:</p>
        <v-select @input="getEstudiantes()" :options="arregloCursos" :reduce="arregloCursos => arregloCursos.codigo" label="cursoparalelo" class="w-full" v-model="comunicacion.curso" />
        <!-- {{ comunicacion.curso }} -->
    </div>
    <div style="margin-top: 25px;" v-if="comunicacion.tipo == 3">
        <p class="font-bold letra">Estudiantes:</p>
        <v-select :options="arregloEstudiantes" :reduce="arregloEstudiantes => arregloEstudiantes.idusuario" label="nombre_completo" class="w-full" v-model="comunicacion.estudiante" />
    </div>
    <br>

    <br>
    <div>
        <p class="font-bold letra">Mensaje:</p>
        <quill-editor class="w-full h-25 alto" v-model="comunicacion.mensaje"></quill-editor>
    </div>
    <br>
    <div>
        <p class="font-bold letra">Archivo adjunto (Máximo {{ limiteMegas }} MB):</p>
        <p class="mt-2">
            <input type="file" name="file1" id="file1" class="inputfile" style="display: none;" v-on:change="mostrarImg()">
            <label for="file1" class="farchivo">
                <feather-icon icon="UploadCloudIcon" svgClasses="h-4 w-4" class="ml-2" style="position: inherit;top:3px" /> <span class="ml-1" style="font-size: 12px;">Buscar Archivo</span>
            </label>
        </p>
    </div>
    <br>
    <div class="flex" style="margin-top: -10px;">
        <div class="flex" v-for="(tr,key) in attachmentArray" :key="key">
            <div class="flex" style="flex-direction: column;">
                <img id="img1" v-if="tr.tipo == 'img'" width="100" class="img-responsive mb-2 ml-1" v-bind:src="tr.img" style="border-radius: 5px;max-height: 60px;">
                <img v-else style="max-height: 60px;width: 50px;" src="@/assets/images/file-icons/doc.png" />
                <small class="mt-1">{{ tr.name }}</small>
            </div>
            <vs-button radius type="line" @click="removeItemFromArr(attachmentArray,tr)" class="ml-2 mt-4" color="danger" icon="delete"></vs-button>
        </div>
    </div>
    <br>
    <div style="margin-top: -5px;" class="flex justify-center">
        <button class="boton">
            <feather-icon icon="SendIcon" svgClasses="h-4 w-4" class="ml-1" style="position: relative;top: 3px;" />
            <span class="ml-1" @click="guardarComunicacion()">Enviar comunicación</span>
        </button>
    </div>
</div>
</template>

<script>
import io from 'socket.io-client';
import moment from 'moment'
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import axios from 'axios'
import {
    quillEditor
} from "vue-quill-editor";
import vSelect from 'vue-select'
export default {
    data() {
        return {
            id: 0,
            usuario: [],
            attachmentArray: [],
            arregloDocentes: [],
            arregloEstudiantes: [],
            arregloCursos: [],
            arregloMaterias: [],
            arregloTipos: [{
                    id: 0,
                    label: "Seleccione el tipo de comunicación..."
                },
                {
                    id: 1,
                    label: "Comunicación general"
                },
                {
                    id: 2,
                    label: "Comunicación a docente"
                },
                {
                    id: 3,
                    label: "Comunicación a estudiante"
                },
            ],
            comunicacion: {
                tipo: 0,
                curso: '',
                usuario: '',
                mensaje: '',
                materia: '',
                estudiante: '',
            },
            fecha_15_dias: null,
            // socket:io(process.env.socket) 
            limiteMegas: 10, //maximo de megas permitido a subir en cada archivo
            bytes: 1048576,
            msjError: 'El peso del archivo excede el limite permitido, verifique antes de continuar',
            porcentaje1: '',
            pesoArchivo1: '',
            muyPesado1: '',
            msj1: '',
        }
    },
    props: {
        institucion_General: {
            type: Object,
            default: () => {}
        },
    },
    created() {
        let me = this;
        me.usuario = JSON.parse(localStorage.getItem("usuario"))[0]
    },
    mounted() {
        let me = this;
        // Conectarse al servidor Socket.io

        if (me.usuario.id_group == 6) {
            //eliminar apartir de la posicion 2 ; 1 elemento
            me.arregloTipos.splice(2, 1)
            me.comunicacion.usuario = me.usuario.idusuario
            me.filtrarCurso()
        }
        //director
        if (me.usuario.id_group == 10) {
            let datos = me.arregloTipos
            me.arregloTipos = datos.filter(p => p.id == 0 || p.id == 2)
        }
        let fechaSuma = me.addDays(15)
        me.fecha_15_dias = moment(fechaSuma).format('YYYY-MM-DD')
    },
    components: {
        vSelect,
        quillEditor,
    },
    methods: {
        filtrarTipos(tipo) {
            let me = this
            me.arregloDocentes = []
            me.arregloCursos = []
            me.arregloEstudiantes = []
            me.comunicacion.curso = ""
            //si fuera docente el usuario conectado no se quita el idusuario
            if (me.usuario.id_group == 6) {} else {
                me.comunicacion.usuario = ""
            }
            me.comunicacion.materia = ""
            me.comunicacion.estudiante = ""
            if (tipo == 2) {
                if (me.usuario.id_group == 6) {
                    me.comunicacion.usuario = me.usuario.idusuario
                }
            }
            if (tipo == 1 || tipo == 3) {
                me.getDocentes()
                return
            }
            if (tipo == 2) return me.getDocentes()
        },
        filtrarCurso() {
            let me = this;
            me.arregloCursos = []
            me.arregloEstudiantes = []
            me.comunicacion.curso = ""
            me.comunicacion.materia = ""
            me.comunicacion.estudiante = ""
            if (me.comunicacion.usuario == null || me.comunicacion.usuario == "" || me.comunicacion.usuario == undefined) {
                me.$vs.notify({
                    text: "Seleccione un docente por favor para filtrar las asignaturas",
                    color: 'warning',
                    iconPack: 'feather',
                    icon: 'icon-check'
                })
                return
            }
            let region = me.institucion_General.region
            // console.log('verificar', 'usuario', me.comunicacion.usuario, 'region', region, 'institucion', me.institucion_General.periodo_id)
            me.$vs.loading();
            this.$http.get(this.$server_url + 'getLibrosDocentes/' + me.comunicacion.usuario + '/' + region + '/' + me.institucion_General.periodo_id)
                .then(function (response) {
                    // console.log('arregloMaterias', response.data)
                    me.arregloMaterias = response.data
                    me.$vs.loading.close();
                })
        },
        getDocentes() {
            let me = this;
            me.arregloDocentes = []
            me.arregloCursos = []
            me.arregloEstudiantes = []
            this.$http.get(this.$server_url + 'docentesInstitucion/' + me.institucion_General.idinstitucion)
                .then(function (res) {
                    me.arregloDocentes = res.data
                })
                .catch(function (error) {
                    console.log(error + ' error');
                })
        },
        getCursosDocente() {
            let me = this;
            if (me.comunicacion.usuario == null || me.comunicacion.usuario == "" || me.comunicacion.usuario == undefined) {
                me.$vs.notify({
                    text: "Seleccione un docente por favor para filtrar las asignaturas",
                    color: 'warning',
                    iconPack: 'feather',
                    icon: 'icon-check'
                })
                return
            }
            if (me.comunicacion.materia == null || me.comunicacion.materia == "" || me.comunicacion.materia == undefined) {
                me.$vs.notify({
                    text: "Seleccione una materia para filtrar los cursos del docente",
                    color: 'warning',
                    iconPack: 'feather',
                    icon: 'icon-check'
                })
                me.arregloCursos = []
                me.arregloEstudiantes = []
                me.comunicacion.curso = ""
                me.comunicacion.materia = ""
                me.comunicacion.estudiante = ""
                return
            }
            me.comunicacion.curso = ''
            let cursos_activos = 'si';
            me.$vs.loading()
            this.$http.get(this.$server_url + 'curso_libro_docente?id_usuario=' + me.comunicacion.usuario + '&id_libro=' + me.comunicacion.materia + '&periodo_id=' + me.institucion_General.periodo_id + '&cursos_activos='+ cursos_activos)
                .then(function (response) {
                    // console.log('cursos',response.data)
                    me.arregloCursos = response.data;
                    me.$vs.loading.close()
                })
                .catch(function () {
                    me.$vs.loading.close()
                })
        },
        getEstudiantes() {
            let me = this;
            // console.log(me.comunicacion)
            if (me.comunicacion.curso == "" || me.comunicacion.curso == null || me.comunicacion.curso == undefined) {
                me.arregloEstudiantes = []
                me.comunicacion.estudiante = ""
            }
            me.arregloEstudiantes = []
            this.$http.get(this.$server_url + 'estudiantexCurso/' + me.comunicacion.curso)
                .then(function (res) {
                    me.arregloEstudiantes = res.data
                })
                .catch(function (error) {
                    console.log(error + ' error');
                })
        },
        guardarComunicacion() {
            let me = this;
            // console.log(me.institucion_General)
            //validate campos vacios
            if (me.comunicacion.tipo == 0 || me.comunicacion.tipo == "" || me.comunicacion.tipo == null || me.comunicacion.tipo == undefined) {
                me.$vs.notify({
                    text: "Seleccione un tipo de comunicación",
                    color: 'warning',
                    iconPack: 'feather',
                    icon: 'icon-check'
                })
                return
            }
            if (me.comunicacion.mensaje == "" || me.comunicacion.mensaje == null || me.comunicacion.mensaje == "null") {
                me.$vs.notify({
                    text: "Ingrese el mensaje por favor",
                    color: 'warning',
                    iconPack: 'feather',
                    icon: 'icon-check'
                })
                return
            }
            //validar si hay periodo
            if (me.institucion_General.periodo_id == undefined || me.institucion_General.periodo_id == "" || me.institucion_General.periodo_id == 0) {
                me.$vs.notify({
                    text: "La institución no tiene periodo, comuníquese con soporte",
                    color: 'warning',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle'
                })
                return
            }
            //=====validar los tipos de comunicaciones====
            //Si selelecciona comunicacion general(tendra que seleccionar un curso)
            if (me.comunicacion.tipo == 1) {
                if (me.comunicacion.curso == "" || me.comunicacion.curso == null || me.comunicacion.curso == undefined) {
                    me.$vs.notify({
                        text: "Debe seleccionar un curso por favor",
                        color: 'warning',
                        iconPack: 'feather',
                        icon: 'icon-check'
                    })
                    return
                }
            }
            //Si selecciona comunicacion a docente(tendra que seleccionar un docente)
            if (me.comunicacion.tipo == 2) {
                if (me.comunicacion.usuario == "" || me.comunicacion.usuario == null || me.comunicacion.usuario == undefined) {
                    me.$vs.notify({
                        text: "Debe seleccionar un docente por favor",
                        color: 'warning',
                        iconPack: 'feather',
                        icon: 'icon-check'
                    })
                    return
                }
            } //Si selecciona comunicacion a estudiante(tendra que seleccionar un curso  estudiante )
            if (me.comunicacion.tipo == 3) {
                if (me.comunicacion.estudiante == "" || me.comunicacion.estudiante == null || me.comunicacion.estudiante == undefined) {
                    me.$vs.notify({
                        text: "Debe seleccionar un estudiante por favor",
                        color: 'warning',
                        iconPack: 'feather',
                        icon: 'icon-check'
                    })
                    return
                }
            }
            //receptor
            var receptor = 0
            if (me.comunicacion.tipo == 1) receptor = me.comunicacion.curso
            if (me.comunicacion.tipo == 2) receptor = me.comunicacion.usuario
            if (me.comunicacion.tipo == 3) receptor = me.comunicacion.estudiante
            //files
            let imgsEnviar = []
            me.attachmentArray.forEach(element => {
                imgsEnviar.push(element.file)
            });
            me.$vs.loading()
            let formData = new FormData();
            formData.append('id', me.id);
            formData.append('tipo_comunicacion', me.comunicacion.tipo);
            formData.append('mensaje', me.comunicacion.mensaje);
            formData.append('id_group', me.usuario.id_group);
            formData.append('user_created', me.usuario.idusuario);
            formData.append('periodo_id', me.institucion_General.periodo_id);
            formData.append('institucion_id', me.institucion_General.idinstitucion)
            formData.append('receptor_id', receptor)
            formData.append('fecha_15_dias', me.fecha_15_dias)
            for (let i = 0; i < this.attachmentArray.length; i++) {
                formData.append('archivos[]', imgsEnviar[i]);
            }
            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            };
            axios.post(this.$data_url + 'api/guadarComunicaciones', formData, config)
                .then(function () {
                    me.$vs.loading.close()
                    me.$vs.notify({
                        text: "Se guardo correctamente",
                        color: 'success',
                        iconPack: 'feather',
                        icon: 'icon-check'
                    })
                    document.getElementById("file1").value = '';
                    me.attachmentArray = []
                    let datos = {
                        tipo_comunicacion: me.comunicacion.tipo,
                        emisor: me.usuario.idusuario,
                        receptor: receptor,
                        grupo: me.usuario.id_group,
                        tipo: "comunicacion",
                    }
                    me.sendSocket(datos)
                    me.limpiar()
                    me.$emit('changeUpdate', true)
                })
                .catch(function () {
                    me.$vs.loading.close()
                })
        },
        sendSocket(datos) {
            try {
                this.$socket.emit("enviar", datos);
            } catch (error) {
                console.log(error)
            }
        },
        mostrarImg() {
            let me = this;
            var archivo = document.getElementById("file1").files[0];

            me.muyPesado1 = false;
            me.pesoArchivo1 = (archivo.size / me.bytes).toFixed(2);
            // console.log(me.pesoArchivo1)
            if (me.pesoArchivo1 > me.limiteMegas) {
                me.muyPesado1 = true;
                me.$vs.notify({
                    text: me.msjError,
                    time: 5000,
                    color: 'warning',
                    iconPack: 'feather',
                    icon: 'icon-alert-triangle'
                })
                return
            }

            var tipo = ""
            if (archivo.type == "image/png" || archivo.type == "image/gif" || archivo.type == "image/jpeg" || archivo.type == "image/jpg") tipo = "img"
            else tipo = "other"
            var reader = new FileReader();
            if (me) {
                reader.readAsDataURL(archivo);
                reader.onloadend = function () {
                    var cal = new Object();
                    cal.file = archivo
                    cal.img = reader.result
                    cal.tipo = tipo
                    cal.name = archivo.name
                    me.attachmentArray.push(cal)
                    //document.getElementById("img"+img).src = reader.result;
                }
            }
        },
        removeItemFromArr(arr, item) {
            const i = arr.indexOf(item)
            arr.splice(i, 1)
        },
        limpiar() {
            let me = this
            me.id = 0
            me.comunicacion.mensaje = ""
            me.comunicacion.tipo = 0
            me.comunicacion.usuario = ""
            me.comunicacion.curso = ""
            me.arregloCursos = []
            me.arregloDocentes = []
            me.arregloEstudiantes = []
        },
        addDays(days) {
            const result = new Date();
            result.setDate(result.getDate() + days);
            return result;
        }
    },
}
</script>

<style scoped>
* {
    font-family: sans-serif;
}

div.scroll {
    margin: 4px, 4px;
    padding: 4px;
    width: 100%;
    height: 85%;
    overflow-x: hidden;
    overflow-y: auto;
    text-align: justify;
}

.letra {
    font-size: 12px;
}

.alto {
    height: 150px;
    display: inline-block;
}

.boton {
    background-color: #1c84c6;
    color: white;
    padding: 10px;
    border-color: #fff !important;
    width: 200px;
    cursor: pointer;
    transition: 0.5s ease-in;
    border: none;
    border-radius: 5px;
}

.boton:hover {
    background-color: #095280;
}

.farchivo {
    margin-bottom: -10px;
    cursor: pointer;
    color: gray;
    width: 100%;
    font-size: 11px;
    line-height: 80%;
    transition: 0.5 ease all;
    padding: 10px 10px;
}

.farchivo:hover {
    background-color: #7C7B89;
    color: white;
    border-radius: 5px;
}
</style>
